/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file
import './scss/frontend.scss';

import { Collapse } from 'bootstrap';

import './js/swiper.js';

import './js/fancybox.js';

import './js/vidstack.js';

document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.getElementById('mobile-nav-toggle');
  const offcanvas = document.getElementById('mobile-nav-offcanvas');
  const offcanvasHeader = offcanvas.querySelector('.offcanvas-header');
  const header = document.querySelector('.site-header--mobile');

  function updateOffcanvasHeaderHeight() {
    if (header && offcanvasHeader) {
      offcanvasHeader.style.minHeight = `${header.offsetHeight}px`;
    }
  }

  offcanvas.addEventListener('show.bs.offcanvas', function () {
    hamburger.classList.add('is-active');

    // Match the height of the header
    updateOffcanvasHeaderHeight();

    // This makes sure the header is at the top of the page when the offcanvas is opened
    // Basically fixes if there is an alert above the header
    if (header) {
      window.scrollTo({ top: header.offsetTop, behavior: 'smooth' });
      setTimeout(() => {
        window.scrollTo({ top: header.offsetTop, behavior: 'smooth' });
      }, 100);
    }
  });

  offcanvas.addEventListener('hide.bs.offcanvas', function () {
    hamburger.classList.remove('is-active');
  });
});

document.querySelectorAll('a[target=_blank]').forEach((a) => {
  const rel = a.rel ? a.rel.split(' ') : [];

  if (rel.includes('noopener')) {
    return;
  }

  rel.push('noopener');

  a.rel = rel.join(' ');
});
